import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";


//Appbars API starts
export const fetchAppbars = createAsyncThunk(
    'globalComponents/fetchAppbars',
    async () => {
        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/global-layouts-repository`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            params: {mode: 'appbar'}
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
);


export const fetchActiveAppbar = createAsyncThunk(
    'globalComponents/fetchActiveAppbar',
    async () => {
        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/global-layout`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            params: {mode: 'appbar'}
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)
export const addAppbar = createAsyncThunk(
    'globalComponents/addAppbar',
    async (payload) => {
        return axios({
            method: 'post',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/global-layout`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            data: payload
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
);
export const saveAppbar = createAsyncThunk(
    'globalComponents/saveAppbar',
    async (payload) => {
        return axios({
            method: 'put',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/global-layout`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            data: payload
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
);

//Appbars API ends







//Drawers API starts
export const fetchDrawers = createAsyncThunk(
    'globalComponents/fetchDrawers',
    async () => {
        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/global-layouts-repository`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            params: {mode: 'drawer'}
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
);


export const fetchActiveDrawer = createAsyncThunk(
    'globalComponents/fetchActiveDrawer',
    async () => {
        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/global-layout`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            params: {mode: 'drawer'}
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)
export const addDrawer = createAsyncThunk(
    'globalComponents/addDrawer',
    async (payload) => {
        return axios({
            method: 'post',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/global-layout`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            data: payload
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
);

export const saveDrawer = createAsyncThunk(
    'globalComponents/saveDrawer',
    async (payload) => {
        return axios({
            method: 'put',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/global-layout`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            data: payload
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)

//Drawers API ends





//Navbars API starts
export const fetchNavbars = createAsyncThunk(
    'globalComponents/fetchNavbars',
    async () => {
        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/global-layouts-repository`,
            headers: {
                'Content-Type': 'application/json',
            },
            params: {mode: 'navbar'}
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
);

export const fetchActiveNavbar = createAsyncThunk(
    'globalComponents/fetchActiveNavbar',
    async () => {
        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/global-layout`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            params: {mode: 'navbar'}
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
);
export const addNavbar = createAsyncThunk(
    'globalComponents/addNavbar',
    async (payload) => {
        return axios({
            method: 'post',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/global-layout`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            data: payload
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
);

export const saveNavbar = createAsyncThunk(
    'globalComponents/saveNavbar',
    async (payload) => {
        return axios({
            method: 'put',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/global-layout`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            data: payload
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)

//Navbars API ends